/* @everyu LINE Tag: respect Shopify's existing consent choices. */
(function () {
  'use strict';
  function start() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || !privacy.marketingAllowed() || !privacy.analyticsProcessingAllowed() || !privacy.saleOfDataAllowed()) return;
    if (window.everyuLineTagStarted) return;
    window.everyuLineTagStarted = true;
    // LINE-generated base code; no purchase event is sent from the storefront.
    (function(g,d,o){
      g._ltq=g._ltq||[];g._lt=g._lt||function(){g._ltq.push(arguments)};
      var h='https://d.line-scdn.net';
      var s=d.createElement('script');s.async=1;
      s.src=o||h+'/n/line_tag/public/release/v1/lt.js';
      var t=d.getElementsByTagName('script')[0];t.parentNode.insertBefore(s,t);
    })(window, document);
    window._lt('init', {
      customerType: 'account',
      tagId: 'f52be530-1de9-4cce-92d5-8730bd55aaab'
    });
    window._lt('send', 'pv', ['f52be530-1de9-4cce-92d5-8730bd55aaab']);
  }
  document.addEventListener('visitorConsentCollected', start);
  if (window.Shopify && window.Shopify.customerPrivacy) start();
  else if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function(error) {
      if (!error) start();
    });
  }
})();
